<template>
<GalleryOverView :isAllowedEdit="isAllowed('gallery_edit')" :isAllowedCSVDownload="isAvailable('gallery:csv_download')"/>
</template>

<script>
import { GalleryOverView } from '@scantrust/st-gallery'
import '@scantrust/st-gallery/dist/index.css'
import { mapGetters } from 'vuex'

export default {
  name: 'Gallery',
  components: {
    GalleryOverView
  },
  computed: {
    ...mapGetters(['isAllowed', 'isAvailable'])
  }
}
</script>

<style scoped lang="sass">

</style>
